<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-section"
      scrollable
      centered
      title="Adicionar Seção"
      button-size="sm"
    >
    <div class="form-group row mb-4">
      <div class="col-md-12 pt-2">
        <label for="txtData"> Nome da Seção:</label>
        <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o Nome da Seção'"
               v-model="form.nome.value"
              :size="form.nome.maxlength"
              :required="form.nome.required"
              :state="form.nome.state">
            </b-form-input>
          </div>
      </div>
      <div class="col-md-12 pt-2">
        <label for="txtData"> PA:</label>
        <div class="input-group">
          <b-form-select v-model="form.pa.value" :options="form.pa.options" placeholder="Selecione o PA">
            <template slot="first"><option :value="null">{{$lang.Common.PlaceholderSelect}}</option></template>
          </b-form-select>
          </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100 text-right">
        <button type="button" class="btn btn-third btn-sm"  v-b-tooltip.hover :title="'Salvar'" @click.prevent="onSave"><i class="fas fa-check-circle"></i><span class="d-md-down-none"> Salvar</span></button>
      </div>
    </template>
    </b-modal>
  </div>
</template>
<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import PARepository from '@/shared/http/repositories/configurations/pa.js'
import GedSecaoRepository from '@/shared/http/repositories/ged/gedsecao.js'

const sectionForm = {
  nome: {
    value: '',
    maxlength: 100,
    required: true,
    state: null
  },
  pa: {
    value: '',
    maxlength: 100,
    required: false,
    state: null
  }
}
const sectionModel = {
  nome: null,
  pa: null
}
export default {
  name: 'ModalSection',
  mixins: [ActionsForm],
  data () {
    return {
      data: sectionModel,
      form: sectionForm
    }
  },
  mounted () {
  },
  methods: {
    showModal () {
      this.onClear()
      this.$refs['modal-section'].show()
    },
    hideModal () {
      this.$refs['modal-section'].hide()
    },
    onLoadAllPAs () {
      PARepository.GetAll()
        .then((response) => {
          this.form.pa.options = response.data.content.map((x) => ({
            value: x.numero,
            text: x.descricao
          }))
        })
        .catch(this.onException)
    },
    onCreate () {
      loading.push()
      GedSecaoRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.hideModal()
          toast.success(this.$lang.Common.Alerts.Success, 'Nova Seção')
          this.$emit('Saved')
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/ged/leftcontent/components/modalsection.vue